module.exports = __webpack_public_path__ + "img/symbol_1.6ed99ad0.png";